import { injectIntl } from "react-intl";
import type { intlFormatPropTypes } from "react-intl";
import { useSelector } from "react-redux";

import { Item } from "@ps-design-system/components/ItemV2";
import MessagesIcon from "@ps-design-system/icons/Messages/Messages24";

import { selectProfileSSOid } from "../../app-main/selectors/profile.selectors";
import { trackTodoItemClicked } from "../analytics/host-hub-analytics";
import useHostHubData from "../hooks/useHostHubData";
import { isSlowResponderHours } from "../services/api/todo/converter";

type HostHubUnreadMessagesItemProps = {
  intl: intlFormatPropTypes;
};

const HostHubUnreadMessagesItem = ({
  intl,
}: HostHubUnreadMessagesItemProps) => {
  const ssoid = useSelector(selectProfileSSOid);
  const { unreadMessages } = useHostHubData();
  const { count: unreadMessagesCount, primaryCtaRoute: unreadMessagesRoute } =
    unreadMessages.card;

  const unreadMessagesTitle = intl.formatMessage(
    {
      defaultMessage:
        "{count, plural, one {# unread message} other {# unread messages}}",
      id: "host_hub.todo_list.unread_messages_title",
    },
    { count: unreadMessagesCount ?? 0 },
  );

  const isSlowResponder = isSlowResponderHours(unreadMessages.data?.hours);
  const unreadMessagesDescription = isSlowResponder
    ? intl.formatMessage({
        defaultMessage:
          "Your average response time is greater than 24 hours. To increase your bookings, improve your response time.",
        id: "host_hub.todo_list.unread_messages_subtitle",
      })
    : undefined;

  return (
    <Item
      buttonOnClick={() => {
        trackTodoItemClicked({
          parameter: isSlowResponder
            ? "slow_response_warning"
            : "unread_messages",
          ssoid,
          unread_count: unreadMessagesCount ?? 0,
        });
        window.location.assign(unreadMessagesRoute);
      }}
      description={unreadMessagesDescription}
      icon={<MessagesIcon />}
      size="lg"
      title={unreadMessagesTitle}
      variant="highlight"
    />
  );
};

export default injectIntl(HostHubUnreadMessagesItem);
